import React from 'react';
import { LightboxProvider, LightboxImageTrigger } from "@/modern/components/ui/lightbox";

interface ImageData {
  src: string;
  alt: string;
  caption?: string;
}

interface SpotIncentiveImagePreviewProps {
  images: ImageData[];
  children: React.ReactNode;
  allowZoom?: boolean;
  enablePreview?: boolean;
}

const SpotIncentiveImagePreview: React.FC<SpotIncentiveImagePreviewProps> = ({
  images,
  children,
  allowZoom = true,
  enablePreview = true,
}) => {
  if (!enablePreview) {
    return <>{children}</>;
  }

  return (
    <LightboxProvider
      images={images}
      allowZoom={allowZoom}
    >
      {children}
    </LightboxProvider>
  );
};

interface ImageThumbnailProps {
  src: string;
  alt: string;
  index: number;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
  interactive?: boolean;
}

export const ImageThumbnail: React.FC<ImageThumbnailProps> = ({
  src,
  alt,
  index,
  className = "w-16 h-16 flex-shrink-0 cursor-pointer hover:opacity-80 transition-opacity",
  onClick,
  interactive = true,
}) => {
  const thumbnail = (
    <div
      className={className}
      onClick={onClick}
    >
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover rounded-md"
      />
    </div>
  );

  if (!interactive) {
    return thumbnail;
  }

  return (
    <LightboxImageTrigger index={index}>
      {thumbnail}
    </LightboxImageTrigger>
  );
};

export default SpotIncentiveImagePreview;
